import React from "react";
import { Formik, Form } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";

import { useAuthentication } from "store/backend/login";
import { ErrorMessage, Heading2, PrimaryButton, TextField } from "widgets";
import Loader from "shared/Loader/Loader";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

import styles from "./Login.module.scss";

const loginSchema = Yup.object({
  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
  password: Yup.string()
    .required("Password is required")
    .min(1, "Password must contain at least 8 character"),
});

const initialValues = {
  mobile: "",
  password: "",
};

const handleSubmit = (values, login, navigate, setSubmitting, openSnackbar) => {
  login(
    {
      mobile: values.mobile,
      password: values.password,
    },
    {
      onSuccess: () => {
        openSnackbar("Login Successful", "success");
        navigate("/homePage");
      },
      onError: (response) => {
        const errorMessages = response.message;
        openSnackbar(errorMessages || "Error fetching tax invoice", "error");
      },
      onSettled: () => {
        setSubmitting(false);
      },
    }
  );
};

const LoginForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openSnackbar } = useSnackbarContext();

  const { mutate: login, isPending } = useAuthentication();

  return (
    <div className={styles.loginContainer}>
      <Heading2 heading="Log In" />
      <Formik
        initialValues={initialValues}
        validationSchema={loginSchema}
        validateOnMount
        onSubmit={(values, { setSubmitting }) =>
          handleSubmit(values, login, navigate, setSubmitting, openSnackbar)
        }
      >
        {(formikProps) => {
          const {
            isValid,
            values,
            touched,
            errors,
            isSubmitting,
            setFieldValue,
            handleBlur,
          } = formikProps;

          return (
            <Form>
              <div className={styles.loginContentContainer}>
                <div className={styles.inputContainer}>
                  <TextField
                    id="mobile"
                    label="Mobile"
                    value={values.mobile}
                    onBlur={handleBlur}
                    onChange={(event) =>
                      setFieldValue("mobile", event.target.value)
                    }
                  />
                  {errors.mobile ? (
                    <ErrorMessage>{errors.mobile}</ErrorMessage>
                  ) : null}
                </div>
                <div className={styles.inputContainer}>
                  <TextField
                    id="password"
                    label="Password"
                    type="password"
                    value={values.password}
                    onBlur={handleBlur}
                    onChange={(event) =>
                      setFieldValue("password", event.target.value)
                    }
                  />
                  {errors.password ? (
                    <ErrorMessage>{errors.password}</ErrorMessage>
                  ) : null}
                </div>
                <div className={styles.btnContainer}>
                  <PrimaryButton
                    type="submit"
                    disabled={!isValid || isSubmitting}
                  >
                    {isPending ? <Loader /> : "Submit"}
                  </PrimaryButton>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const Login = () => (
  <div className={styles.rootContainer}>
    <LoginForm />
  </div>
);

export default Login;
